import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { TaxpayerAuthenticationConfigDTO } from '../../../types/hacienda/TaxpayerAuthenticationTypes';

interface TaxpayerAuthenticationState {
  form: TaxpayerAuthenticationConfigDTO;
  isLoading: boolean;
  isSubmitting: boolean;
  error: string | null;
}

const initialState: TaxpayerAuthenticationState = {
  form: {
    id: undefined,
    taxId: undefined,
    apiKey: undefined,
    privateKeyPassword: undefined,
    active: true,
    createdAt: undefined,
    updatedAt: undefined,
  },
  isLoading: false,
  isSubmitting: false,
  error: null,
};

const taxpayerAuthenticationConfigSlice = createSlice({
  name: 'taxpayerAuthenticationConfig',
  initialState,
  reducers: {
    setTaxpayerAuthenticationLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setTaxpayerAuthenticationSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },
    setTaxpayerAuthenticationError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setTaxpayerAuthenticationConfig(
      state,
      action: PayloadAction<TaxpayerAuthenticationConfigDTO>
    ) {
      state.form = action.payload;
      state.error = null;
    },
    updateTaxpayerAuthenticationField<K extends keyof TaxpayerAuthenticationConfigDTO>(
      state: Draft<TaxpayerAuthenticationState>,
      action: PayloadAction<{ field: K; value: TaxpayerAuthenticationConfigDTO[K] }>
    ) {
      const { field, value } = action.payload;
      state.form[field] = value;
    },
    resetTaxpayerAuthenticationConfig(state) {
      state.form = initialState.form;
      state.isSubmitting = false;
      state.error = null;
    },
  },
});

export const {
  setTaxpayerAuthenticationLoading,
  setTaxpayerAuthenticationSubmitting,
  setTaxpayerAuthenticationError,
  setTaxpayerAuthenticationConfig,
  updateTaxpayerAuthenticationField,
  resetTaxpayerAuthenticationConfig,
} = taxpayerAuthenticationConfigSlice.actions;

export default taxpayerAuthenticationConfigSlice.reducer;
